const carousel = document.getElementById("carousel");
const prevButton = document.getElementById("prev");
const nextButton = document.getElementById("next");

if (carousel && carousel.children.length > 0) {
  const clientWidth = carousel.firstElementChild?.clientWidth || 0; // Width of one slide

  const style = window.getComputedStyle(carousel.firstElementChild!);

  const gap = 0;
  const marginLeft = parseFloat(style.marginLeft);
  const marginRight = parseFloat(style.marginRight);
  const slideWidth = clientWidth + marginLeft + marginRight + gap;
  // Move to the previous slide
  prevButton?.addEventListener("click", () => {
    carousel.scrollBy({
      left: -slideWidth,
      behavior: "smooth",
    });
    // Scroll to the last slide
    if (carousel.scrollLeft <= 0) {
      carousel.scrollBy({
        left: carousel.scrollWidth,
        behavior: "smooth",
      });
    }
  });

  // Move to the next slide
  nextButton?.addEventListener("click", () => {
    carousel.scrollBy({
      left: slideWidth,
      behavior: "smooth",
    });
    // Scroll to the first slide
    if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth) {
      carousel.scrollBy({
        left: -carousel.scrollWidth,
        behavior: "smooth",
      });
    }
  });
}
